<template>
  <section class="section-base">
    <div class="container">
      <div class="row" data-anima="fade-bottom" data-time="1000">
        <div class="col-lg-12">
          <div class="title">
            <h2>A SKY SOLAR </h2>
            <p>QUEM SOMOS</p>
          </div>
          <p align="justify">
            &nbsp;&nbsp;Somos uma família de profissionais comprometidos e apaixonados que aproveita
            nossa rica herança solar para garantir que nossos clientes e parceiros tenham sucesso
            na construção do ecossistema solar que criará um planeta movido pelo sol.<br><br>
            &nbsp;&nbsp;A Sky Solar tem como foco prover soluções para que nossos parceiros tenham
            confiança em entregar a solução completa ao consumidor final. Nossa matriz, localizada
            em Maringá-PR, conta com uma estrutura robusta para agilidade nos envios e atendimento
            atencioso, abordagem única a cada situação e ambiente, trazendo as mais avançadas
            tecnologias do mercado, com equipamentos homologados e certificados. Atendendo as
            necessidades modernas com a indispensável responsabilidade dos tempos atuais, a nossa
            missão é prover soluções em energia solar duradouras e confiáveis, para que nossos
            parceiros possam desenvolver suas atividades principais com autonomia e tranquilidade.
            Temos um compromisso com nossos clientes e com o meio ambiente.
          </p>
          <a href="#" class="btn-text active">Saiba mais</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'QuemSomos',
};
</script>

<style scoped>

</style>
